import { SelectOption } from '../models';

export enum TypeOccasion {
  REGULAR = 0,
  EVENTS = 1,
}

export const TypeOccasions: SelectOption[] = [
  { value: TypeOccasion.REGULAR, label: 'Regular' },
  { value: TypeOccasion.EVENTS, label: 'Events' },
];
